import { render, staticRenderFns } from "./Denuncia.vue?vue&type=template&id=04c28400&"
import script from "./Denuncia.vue?vue&type=script&lang=js&"
export * from "./Denuncia.vue?vue&type=script&lang=js&"
import style0 from "./Denuncia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports